import keys from '@debbie/common/dist/cache/keys.js';
import { VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { formatNumber } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as billingVoucherAPI from '@debbie/cortex/dist/api/billing-vouchers.js';
import { billingVouchersEntity } from '@debbie/cortex/dist/billing-vouchers/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../utils/errors.js';
import { Col, Row } from '../../Grid/index.js';
import { Button, Checkbox, DateInput, Input, SearchInput } from '../../index.js';
import MoneyInput from '../../MoneyInput.js';
const voucherWithHourlyRate = {
    [VoucherTypeIds.JURIDISKBISTAND]: true,
};
const VoucherCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(props.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const tenant = useTenant();
    const [amount, setAmount] = useState(null);
    const [text, setText] = useState(null);
    const [date, setDate] = useState(new Date());
    const [hourlyRate, setHourlyRate] = useState(true);
    const [hourlyRateAmount, setHourlyRateAmount] = useState(null);
    const [hourlyRateHours, setHourlyRateHours] = useState('');
    const [hourlyRateMinutes, setHourlyRateMinutes] = useState('');
    const [voucherType, setVoucherType] = useState(null);
    const isVoucherWithHourlyRate = voucherType &&
        voucherWithHourlyRate[voucherType.voucherTypeId] &&
        hourlyRate;
    const setListPrice = (_voucherTypeId) => {
        switch (_voucherTypeId) {
            case null:
                setAmount(null);
                setHourlyRateAmount(null);
                break;
            case VoucherTypeIds.BPKDISBURSEMENT:
                setAmount(75000);
                break;
            case VoucherTypeIds.FOGEDDISBURSEMENT:
                setAmount(75000);
                break;
            case VoucherTypeIds.POLICEDISBURSEMENT:
                setAmount(40000);
                break;
            case VoucherTypeIds.ENDCASEFEE:
                setAmount(handlePriceHierarchy(creditor?.priceList?.caseCloseFee, tenant?.priceList?.caseCloseFee));
                break;
            case VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE:
                setAmount(handlePriceHierarchy(creditor?.priceList?.debtRegisterRegistrationFee, tenant?.priceList?.debtRegisterRegistrationFee));
                break;
            case VoucherTypeIds.BPKFEE:
                setAmount(handlePriceHierarchy(creditor?.priceList?.paymentDemandFee, tenant?.priceList?.paymentDemandFee));
                break;
            case VoucherTypeIds.FOLKEREGISTEROPSLAG:
                setAmount(handlePriceHierarchy(creditor?.priceList?.folkeregisteropslagsFee, tenant?.priceList?.folkeregisteropslagsFee));
                break;
            case VoucherTypeIds.ANMELDELSEAFKRAV:
                setAmount(handlePriceHierarchy(creditor?.priceList?.anmeldelseAfKravFee, tenant?.priceList?.anmeldelseAfKravFee));
                break;
            case VoucherTypeIds.FOGEDFEE:
                setAmount(handlePriceHierarchy(creditor?.priceList?.fogedrekvisitionsFee, tenant?.priceList?.fogedrekvisitionsFee));
                break;
            case VoucherTypeIds.JURIDISKBISTAND:
                setHourlyRateAmount(handlePriceHierarchy(creditor?.priceList?.legalAdviceHourlyRate, tenant?.priceList?.legalAdviceHourlyRate));
                break;
            case VoucherTypeIds.STARTCASEFEE:
                setAmount(handlePriceHierarchy(creditor?.priceList?.tenantCaseCreationFee, tenant?.priceList?.tenantCaseCreationFee));
                break;
            case VoucherTypeIds.AFLYSNINGAFUDLAEG:
                setAmount(handlePriceHierarchy(creditor?.priceList?.afslysningAfUdlaeg, tenant?.priceList?.afslysningAfUdlaeg));
                break;
            default:
                break;
        }
    };
    const getHourlyRateAmount = () => {
        if (isVoucherWithHourlyRate) {
            return typeof hourlyRateAmount === 'number' ? hourlyRateAmount : null;
        }
        else {
            return null;
        }
    };
    const getHourlyRateHours = () => {
        if (isVoucherWithHourlyRate) {
            const h = parseInt(hourlyRateHours.replace(',', '.'));
            return isNaN(h) ? null : h;
        }
        else {
            return null;
        }
    };
    const getHourlyRateMinutes = () => {
        if (isVoucherWithHourlyRate) {
            const h = parseInt(hourlyRateMinutes.replace(',', '.'));
            return isNaN(h) ? null : h;
        }
        else {
            return null;
        }
    };
    const getAmount = () => {
        if (isVoucherWithHourlyRate) {
            if (amount !== null) {
                return amount;
            }
            else {
                const _amount = getHourlyRateAmount();
                const _hours = getHourlyRateHours();
                const _minutes = getHourlyRateMinutes() || 0;
                if (typeof _amount === 'number' && typeof _hours === 'number') {
                    return Math.round(_amount * _hours + (_minutes / 60) * _amount);
                }
                return null;
            }
        }
        else {
            return amount === null ? null : amount;
        }
    };
    const getText = () => {
        if (text !== null) {
            return text;
        }
        const _amount = getHourlyRateAmount();
        const _hours = getHourlyRateHours();
        const _minutes = getHourlyRateMinutes() || 0;
        if (typeof _amount === 'number' && typeof _hours === 'number') {
            return `${_hours.toString().replace('.', ',')}:${_minutes
                .toString()
                .replace('.', ',')} ${_hours > 1 ? lang.clientBilling.hoursOf : lang.clientBilling.hourOf} ${props.currency} ${formatNumber(_amount)}`;
        }
        else {
            return '';
        }
    };
    const addVoucherMutation = useMutation(async () => {
        const _amount = getAmount();
        if (!voucherType?.voucherTypeId) {
            throw new Error('No voucher type selected');
        }
        if (typeof _amount !== 'number') {
            throw new Error('No amount');
        }
        await billingVoucherAPI.add(props.caseId, {
            currency: props.currency,
            voucherTypeId: voucherType?.voucherTypeId,
            amount: _amount,
            date: moment(date).format(),
            caseId: props.caseId,
            text: getText() || undefined,
        });
        q.invalidate([...keys.write.create(billingVouchersEntity)]);
        if (props.onAdd) {
            props.onAdd();
        }
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.caseVoucher);
        },
    });
    return (React.createElement("div", null,
        React.createElement(SearchInput, { placeholder: lang.clientBilling.voucherType, forceOpen: true, searchAll: (q) => (q != null && q !== ''
                ? props.types.filter((type) => (lang.economyVoucherTypeLabels[type.voucherTypeId] ||
                    type.label ||
                    '')
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                : props.types).map((type) => {
                const voucherType = voucherTypes?.find((voucherType) => voucherType.voucherTypeId === type.voucherTypeId);
                return {
                    heading: lang.economyVoucherTypeLabels[type.voucherTypeId] || type.label,
                    subheading: voucherType
                        ? lang.economyCategories[voucherType.category]
                        : undefined,
                    returnData: type,
                    key: type.voucherTypeId,
                };
            }), static: (voucherType &&
                lang.economyVoucherTypeLabels[voucherType.voucherTypeId]) ||
                voucherType?.label, onSelect: (type) => {
                setVoucherType(type);
                setListPrice(type.voucherTypeId);
            }, onRemoveStatic: () => {
                setVoucherType(null);
                setListPrice(null);
            } }),
        React.createElement(DateInput, { placeholder: lang.economy.date, value: moment(date), allowNull: false, onChange: (d) => {
                setDate(d.toDate());
            } }),
        voucherType && voucherWithHourlyRate[voucherType.voucherTypeId] && (React.createElement(React.Fragment, null,
            React.createElement(Checkbox, { placeholder: lang.clientBilling.hourlyRateOn, checked: hourlyRate, onChange: (e) => {
                    setHourlyRate(e.target.checked);
                } }),
            hourlyRate && (React.createElement(React.Fragment, null,
                React.createElement(MoneyInput, { placeholder: lang.clientBilling.hourlyRate, allowNull: true, value: hourlyRateAmount, onChange: (a) => {
                        setHourlyRateAmount(a);
                    } }),
                React.createElement(Row, null,
                    React.createElement(Col, { width: "6" },
                        React.createElement(Input, { placeholder: lang.clientBilling.hourlyRateHours, type: "number", value: hourlyRateHours, onChange: (d) => {
                                setHourlyRateHours(d.target.value);
                            } }),
                        React.createElement("span", { style: {
                                position: 'absolute',
                                right: '-3px',
                                top: '5px',
                                fontSize: '1.5em',
                            } }, ":")),
                    React.createElement(Col, { width: "6" },
                        React.createElement(Input, { placeholder: lang.clientBilling.hourlyRateMinutes, type: "number", value: hourlyRateMinutes, onChange: (d) => {
                                setHourlyRateMinutes(d.target.value);
                            } }))))))),
        React.createElement(Input, { placeholder: lang.clientBilling.text, value: getText(), onChange: (d) => {
                setText(d.target.value);
            } }),
        React.createElement(MoneyInput, { value: getAmount(), allowNull: true, onChange: (c) => {
                setAmount(c);
                setHourlyRateAmount(null);
                setHourlyRateHours('');
                setHourlyRateMinutes('');
            }, placeholder: lang.economy.amount, disabled: !!(voucherType &&
                voucherWithHourlyRate[voucherType.voucherTypeId] &&
                hourlyRate) }),
        React.createElement(Button, { onClick: () => addVoucherMutation.mutate(), loading: addVoucherMutation.isLoading, disabled: !(voucherType &&
                date &&
                date.getTime() &&
                typeof getAmount() === 'number'), block: true }, lang.clientBilling.addVoucher)));
};
export default VoucherCreator;
const handlePriceHierarchy = (...prices) => {
    for (let i = 0; i < prices.length; i++) {
        const price = prices[i];
        if (typeof price === 'number') {
            return price;
        }
    }
    return null;
};
//# sourceMappingURL=VoucherCreator.js.map